import { KitDefinition } from '@wix/editor-kits';
import _ from 'lodash';
import { getPreferredPresets } from '../chatController/utils';
import { IKitToUseService } from '../types';

export class KitsToUseService implements IKitToUseService {
  private kitDefinitions: KitDefinition[];

  public init(kitDefinition: KitDefinition[]) {
    this.kitDefinitions = kitDefinition;
  }

  public getInitialKit() {
    return _.sample(getPreferredPresets(this.kitDefinitions)) as KitDefinition;
  }

  private getRegenerateKits(
    currentKit: KitDefinition,
    usedKits: KitDefinition[],
  ) {
    const usedKitTitles = (usedKits ?? []).map((kit) => kit.title);

    const optionalKitsWithoutUsed = this.kitDefinitions.filter(
      (kit) => !usedKitTitles.includes(kit.title),
    );

    if (optionalKitsWithoutUsed.length > 0) {
      return getPreferredPresets(optionalKitsWithoutUsed);
    }

    const kitsWithoutCurrent = this.kitDefinitions.filter(
      (kit) => kit.title != currentKit.title,
    );

    return getPreferredPresets(kitsWithoutCurrent);
  }

  public getRegenerateKit(
    currentKit: KitDefinition,
    usedKits: KitDefinition[],
  ) {
    return _.sample(
      this.getRegenerateKits(currentKit, usedKits),
    ) as KitDefinition;
  }
}
